import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'phosphor-react';

interface Props {
  title: string;
  eyebrow?: string;
  italicWord?: string;
  right?: ReactNode;
  back?: boolean;
}

export function PageHeader({ title, eyebrow, italicWord, right, back }: Props) {
  const nav = useNavigate();
  let body: ReactNode = title;
  if (italicWord) {
    const idx = title.toLowerCase().indexOf(italicWord.toLowerCase());
    if (idx >= 0) {
      const before = title.slice(0, idx);
      const match = title.slice(idx, idx + italicWord.length);
      const after = title.slice(idx + italicWord.length);
      body = <>{before}<em className="italic-keyword">{match}</em>{after}</>;
    }
  }
  return (
    <header className="px-5 pt-[max(env(safe-area-inset-top),16px)] pb-5 flex items-end gap-3">
      {back && (
        <button onClick={() => nav(-1)} className="h-10 w-10 rounded-full grid place-items-center bg-paper-elev ring-1 ring-paper-edge -ml-1">
          <ArrowLeft size={18} />
        </button>
      )}
      <div className="flex-1 min-w-0">
        {eyebrow ? <div className="t-cap mb-1.5">{eyebrow}</div> : null}
        <h1 className="t-ed-2xl">{body}</h1>
      </div>
      {right}
    </header>
  );
}
